var convert = require('./convert'),
    func = convert('flow', require('../flow'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/fp/flow.js
// module id = 1101
// module chunks = 0